"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SYSTEM_LANG = exports.SYSTEM_LANGS = void 0;
const __1 = require("..");
exports.SYSTEM_LANGS = __1.ADMIN.child("/langs");
exports.SYSTEM_LANG = __1.ADMIN.child("/langs/:langId");
